<script setup>
import {onMounted, ref, watchEffect} from "vue";
import router from "@/router";
import Swal from "sweetalert2";
import {useRoute} from "vue-router";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {useTimer} from "vue-timer-hook";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {useStore} from "vuex";
import { OTP } from 'vue3-otp-input-field';

document.body.scrollTop = 0
document.documentElement.scrollTop = 0

let loading = ref(false)

let store = useStore()

let otp_user = ref("")
let phone = useRoute().params.phone;
let code_try = ref(false)


const time = new Date();
time.setSeconds(time.getSeconds() + 50); // 10 minutes timer
const timer = useTimer(time);
const try_send_code = () => {
  // Restarts to 5 minutes timer
  const time = new Date();
  time.setSeconds(time.getSeconds() + 50);
  timer.restart(time);

  FreeWorld.Heisenberg({action: 'phone', phone: phone,}, 'otp').then(() => {
    console.log('پیامک ارسال گردید')
  }).catch((res) => {
    Swals.Catch(res, try_send_code)
  })
}

onMounted(() => {
  watchEffect(async () => {
    if (timer.isExpired.value) {
      console.warn('IsExpired')
      code_try.value = true
    } else {
      code_try.value = false
    }
  })
})

const handleOnComplete = () => {

  let data = {
    phone: phone,
    otp: otp_user.value,
    action: 'otp',
  }

  loading.value = true

  FreeWorld.Heisenberg(data , 'otp').then((result) => {

    loading.value = false
    var res = result.data

    if (res.status !== 'ok') {

      Swal.fire({
        icon: 'warning',
        title: 'کد وارد شده صحیح نمیباشد.',
        confirmButtonText: 'متوجه شدم',
        showClass: {
          popup: 'animate__animated animate__bounceInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__bounceOutUp'
        }
      })

    } else if (res.event === 'not user') {

      router.push({name: 'RegisterPage', params: {phone: phone}})

    } else if (res.event === 'is user') {

      FreeWorld.Heisenberg({action: 'show',user_id:res.id}, 'user_edit').then((result) => {

        let res = result.data
        store.commit('set_my_profile', res)

        localStorage.setItem('uid', FreeWorld.PinkMan(res.id , 'en'))
        window.location.href = '/HomePage'

      }).catch((res)=>{
        Swals.Catch(res, handleOnComplete)
      })

    }else {
      Swal.fire({
        icon:'error',
        title: 'متاسفانه مشکلی رخ داده است',
        confirmButtonText: 'متوجه شدم',
        showClass: {
          popup: 'animate__animated animate__bounceInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__bounceOutUp'
        }
      })
    }

  }).catch((result) => {
    loading.value = false
    Swals.Catch(result , handleOnComplete)
  })
};

function logOtpValue(val) {
  let [a , b , c , d] = val

  otp_user.value = `${a}${b}${c}${d}`

  if (otp_user.value.length === 4) handleOnComplete()
}

</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div id="main" :class="loading ? 'activeClass' : '' " class="animate__animated animate__fadeIn position-relative">
    <img class="bg-login" src="../assets/img/bg-login.png" alt=""/>
    <div class="w-100 position-relative">
      <br>
      <br>
      <br>
      <br>
      <img class="img-logo d-block mx-auto mb-5" src="../assets/img/logo_app.svg" alt=""/>
      <img style="height: 50px" class="d-block mx-auto" src="../assets/img/logo_splash.png" alt=""/>
    </div>
    <br>
    <br>
    <div class="div-blur d-block mx-auto p-body">
      <br>
      <br>
      <p
          style="text-shadow: 2px 2px 2px #6e6d6d"
          class="font-3 text-white text-center"
      >
        کد ارسال را وارد کنید
      </p>
      <br>
      <div class="d-flex justify-content-center">
        <OTP
            dir="ltr"
            size="small"
            inputstyle=""
            ref="otpInput"
            className="otp-input"
            :fields="4"
            type="number"
            @OTPValueChanged="logOtpValue"
        />
      </div>
      <p class="font-4 mt-2 text-center">
        <span id="timeLeft">00:{{ timer.seconds }}</span>
      </p>
      <!-- == -->
      <div class="div-a w-50 d-flex mx-auto justify-content-between">
        <a v-if="code_try" @click="try_send_code" class="font-4 text-dark float-end">ارسال مجدد</a>
        <router-link to="/LoginPage" class="font-4 text-dark float-start">
          ویرایش شماره
        </router-link>
      </div>
      <!-- = -->
      <br/>
      <button
          @click="send_code"
          class="bg-color shadow-lg text-white btn-number d-block mx-auto rounded font-4"
          type="submit"
      >
        ثبت
      </button>
    </div>
  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="container-fluid animate__animated animate__fadeIn bg-color-holder position-relative">

    <div class="center-y w-100">
      <div class="div-blur d-block mx-auto p-body">
        <br>
        <br>
        <p
            style="text-shadow: 2px 2px 2px #6e6d6d"
            class="font-3 text-white text-center"
        >
          کد ارسال را وارد کنید
        </p>
        <br>
        <div class="d-flex justify-content-center">
          <OTP
              dir="ltr"
              size="small"
              inputstyle=""
              ref="otpInput"
              className="otp-input"
              :fields="4"
              type="number"
              @OTPValueChanged="logOtpValue"
          />
        </div>
        <p class="font-4 mt-2 text-center">
          <span id="timeLeft">00:{{ timer.seconds }}</span>
        </p>
        <!-- == -->
        <div class="div-a w-50 d-flex mx-auto justify-content-between">
          <a v-if="code_try" @click="try_send_code" class="font-4 text-dark float-end">ارسال مجدد</a>
          <router-link to="/LoginPage" class="font-4 text-dark float-start">
            ویرایش شماره
          </router-link>
        </div>
        <!-- = -->
        <br/>
        <button
            @click="send_code"
            class="bg-color shadow-lg text-white btn-number d-block mx-auto rounded font-4"
            type="submit"
        >
          ثبت
        </button>
      </div>
    </div>

  </div>

</template>

<style scoped>
.bg-color-holder {
  background-image: linear-gradient(to top, #FFAF73, #FF9900);
}

.bg-login {
  height: 100dvh;
  position: absolute;
  top: -5px;
  right: -5px;
  width: 103%;
  max-width: 700px;
}

.img-logo {
  height: 10rem;
}

.div-blur {
  background-color: rgba(255, 255, 255, 0.2);
  /* background-color: #1a1222; */
  border-radius: 30px;
  width: 90%;
  max-width: 470px;
  /* filter: blur(1px); */
  /* -webkit-filter: blur(8px); */
  -webkit-backdrop-filter: blur(10px);
  height: 400px;
  /* opacity: 0.8; */
  top: 20px;
  position: relative;
  /* z-index: 1; */
  backdrop-filter: saturate(1) blur(10px);
  /* backdrop-filter: blur(100px); */
}

.btn-number {
  width: 60%;
  border: none;
  line-height: 40px;
}

input::placeholder {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}
</style>